export const environment = {
  production: true,
  apiBase: 'https://thirtysecondfart.com',
  siteName: 'Thirty Second Fart',
  companyName: '',
  businessAddress: '',
  supportEmail: 'noisythangs@gmail.com',
  supportPhone: '',
  ageGateEnabled: false,
  coppaMode: false,
  privacyEffectiveDate: 'January 1, 2026',
  termsEffectiveDate: 'January 1, 2026',
  cookieEffectiveDate: 'January 1, 2026',
  dmcaAgentName: '',
  dmcaAgentEmail: '',
  dmcaAgentAddress: '',
  analyticsProvider: '',
  featureFlags: {
    scheduleFixed: false,
    scheduleRandom: false,
    scheduleAt: false,
  },
};
